"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.wizardAssignPackagesFromBuildOutputDtoSchema = exports.wizardAssignPackagesFromBuildInputDtoSchema = void 0;
const z = __importStar(require("zod"));
const wizard_assign_training_packages_dto_js_1 = require("./wizard-assign-training-packages.dto.js");
exports.wizardAssignPackagesFromBuildInputDtoSchema = z.object({
    buildId: z.string().min(1),
    user: z.string().optional(),
    organization: z.string().optional(),
    seedMode: z.enum(['blank', 'aiDraft', 'latest']).optional(),
});
exports.wizardAssignPackagesFromBuildOutputDtoSchema = z.object({
    organizationId: z.string(),
    results: z.array(wizard_assign_training_packages_dto_js_1.wizardAssignTrainingPackageResultSchema),
    filesGrantedCount: z.number().int().nonnegative(),
    candidatePackageCount: z.number().int().nonnegative(),
    eligiblePackageCount: z.number().int().nonnegative(),
});
//# sourceMappingURL=wizard-assign-packages-from-build.dto.js.map